import BSCornMasaFlourProduct from 'models/BSCornMasaFlourProduct'

export const packagingInitialState = {
  category: BSCornMasaFlourProduct.category,
  subCategory: BSCornMasaFlourProduct.subCategory,
  Size: BSCornMasaFlourProduct.Size,
  Organic: BSCornMasaFlourProduct.Organic,
}
